import { createFileRoute } from "@tanstack/react-router";
import AdminCardDetailPage from "@/admin/pages/card-detail";

export const Route = createFileRoute("/admin/cards/$id")({
  component: AdminCardDetailPage,
});
